import { ResultDto } from "../../../Model/CommonModels"
import { DELETE_LOG_UNDO, RESUME_SUSPEND_LOG_UNDO } from "../../../Model/Log"

const initState: ResultDto = {
    data: undefined,
    info: undefined,
    warning: undefined
}
//const dispatch = useDispatch();


export const LogUndoDeleteReducer = (state = initState, action: { type: string, payload: ResultDto }) => {
    switch (action.type) {
        case DELETE_LOG_UNDO:
            {
                return { ...state, ResultDto: action.payload }
            }
            case RESUME_SUSPEND_LOG_UNDO:
                return { ...state, ResultDto: action.payload }

        default:
            return state;
    }
}
